import React, {useEffect, useState} from 'react';

import './Results.scss';

import { ProductCard } from "../ProductCard";
import { ResultsRefinements } from '../ResultsRefinements/ResultsRefinements';
import { useInfiniteHits } from 'react-instantsearch-hooks-web';
import useDebounce from '../../../../../_shared/services/useDebouncer';
import Util from '../../../../../../../src/js/Util';

function CustomInfiniteHits(props) {

    const [version, setVersion] = useState(1);
    const [priceState, setPriceState] = useState('');

    const {
        hits,
        currentPageHits,
        results,
        isFirstPage,
        isLastPage,
        showPrevious,
        showMore,
        sendEvent,
    } = useInfiniteHits(props);

    const debounce = useDebounce();

    const getItemContainer = () => {
        return document.querySelector('.ais-InfiniteHits-list');
    }

    const itemListChanged = () => {
        const targetNode = getItemContainer();
        const event = new CustomEvent( 'product-cards-loaded', { detail: { node: targetNode } } );
        document.dispatchEvent( event );
    }

    const updatePrices = ( evt ) => {

        setPriceState( '' );

        const prices = evt.detail.items;

        if ( undefined === prices || Object.entries( prices ).length <= 0 ){
            return;
        }

        for ( let i : number = 0; i < hits.length; i++ ) {
            // @ts-ignore
            if ( prices[ hits[i].post_id ] ) {
                // @ts-ignore
                hits[i].price_override = prices[ hits[i].post_id ].value;
            }
        }

        setVersion( version + 1 );

        setPriceState( 'changed' );

        setTimeout(() => {
            setPriceState( '' );
        }, 2 * 1000 );
    };

    useEffect(() => {

        if ( hits.length <= 0 )
            return;

        debounce( () => {
            itemListChanged();
        }, 300 );

    }, [hits.length]);

    document.addEventListener( 'prices/changed', updatePrices );

    const additionalClasses = (priceState === 'changed' ? ' prices-changed' : '');

    return (
        <div className={`ais-InfiniteHits product-cards ${additionalClasses}`}>
            { !isFirstPage &&
                <button
                    className="ais-InfiniteHits-loadPrevious ais-InfiniteHits-loadBtn"
                    onClick={() => {showPrevious()}}
                >
                    {Util.translate('Show more')}
                </button>
            }
            <ol className="ais-InfiniteHits-list">
                {
                    hits.map( ( item, i ) => (
                        <li className="ais-InfiniteHits-item" key={i} data-version={version}>
                            <ProductCard hit={item} />
                        </li>
                    ))
                }
            </ol>
            { !isLastPage &&
                <button
                    className="ais-InfiniteHits-loadMore ais-InfiniteHits-loadBtn"
                    onClick={() => {showMore()}}
                >
                    {Util.translate('Show more')}
                </button>
            }

            <div style={{display: "none"}}>Hits: {hits.length}</div>
            <div style={{display: "none"}}>Page: {results.page}</div>

        </div>
    );
}

function CustomEmptyResults( props ) {

    const { hits } = useInfiniteHits( props );

    if ( hits.length > 0 )
        return;

    return (
        <div>No results found. Try a different search keyword.</div>
    );
}

export class Results extends React.Component<any, any> {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="algolia-results">

                <ResultsRefinements toggleFiltering={this.props.toggleFiltering} {...this.props} />

                <div className="results-body">
                    <div className="container">
                        <CustomInfiniteHits />
                        <CustomEmptyResults />
                    </div>
                </div>

            </div>
        );
    }
}
